import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue'),
    },
    {
      path: '/lokasi/:kota',
      name: 'lokasi',
      component: () => import('../views/HomeView.vue'),
    },
    {
      path: '/jobs/:slug',
      name: 'job-detail',
      component: () => import('../views/JobDetailView.vue'),
    },
    {
      path: '/bookmarks',
      name: 'bookmarks',
      component: () => import('../views/BookmarkView.vue'),
    },
    {
      path: '/history',
      name: 'history',
      component: () => import('../views/HistoryView.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/AboutView.vue'),
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('../views/FaqView.vue'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/ContactView.vue'),
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('../views/TermsView.vue'),
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('../views/PrivacyPolicyView.vue'),
    },
    {
      path: '/post-job',
      name: 'post-job',
      component: () => import('../views/PostJobOrderView.vue'),
    },
    {
      path: '/post-job/form',
      name: 'post-job-form',
      component: () => import('../views/PostJobFormView.vue'),
    },
    {
      path: '/payment/:referenceId',
      name: 'payment',
      component: () => import('../views/PaymentView.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.name === from.name && JSON.stringify(to.query) !== JSON.stringify(from.query)) {
      return false;
    }
    return { top: 0 };
  },
});

export default router;
